import React, { useEffect, useRef, useState } from "react";
import "./Home.css";

/* ── Check icon helper ──────────────────────────────────────── */
const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="#10b981"
    viewBox="0 0 16 16"
    style={{ flexShrink: 0, marginTop: 3 }}
  >
    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
  </svg>
);

/* ── Arrow icon helper ──────────────────────────────────────── */
const ArrowIcon = ({ color = "white", size = 15 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2.5"
  >
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

/* ── Hero Phone Mockup ──────────────────────────────────────── */
function HeroPhone() {
  const orders = [
    {
      ico: "💧",
      name: "20L Can × 1 — Home",
      meta: "On the way · Driver Raju",
      badge: "Arriving",
      bg: "rgba(251,146,60,.15)",
      tc: "#fb923c",
    },
    {
      ico: "🫙",
      name: "5L Jar × 2 — Tomorrow",
      meta: "Scheduled · 8:00 AM",
      badge: "Scheduled",
      bg: "rgba(56,189,248,.15)",
      tc: "#38bdf8",
    },
    {
      ico: "⭐",
      name: "Weekly Sub — Active",
      meta: "Next: Monday 8am",
      badge: "Active",
      bg: "rgba(16,185,129,.15)",
      tc: "#34d399",
    },
  ];
  return (
    <div className="d-flex justify-content-center align-items-center position-relative">
      <div className="montclair-home-ring montclair-home-ring-1" />
      <div className="montclair-home-ring montclair-home-ring-2" />
      <div className="montclair-home-ring montclair-home-ring-3" />

      <div className="montclair-home-phone">
        <div className="montclair-home-phone-notch" />
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: 22,
                height: 22,
                borderRadius: 6,
                background: "linear-gradient(135deg,#0369a1,#06b6d4)",
              }}
            />
            <span
              style={{
                fontFamily: "Sora,sans-serif",
                fontSize: ".74rem",
                fontWeight: 700,
                color: "#fff",
              }}
            >
              Montclair
            </span>
          </div>
          <div
            style={{
              width: 8,
              height: 8,
              borderRadius: "50%",
              background: "#06b6d4",
            }}
          />
        </div>
        <div
          style={{
            fontSize: ".67rem",
            color: "#94a3b8",
            marginBottom: ".12rem",
          }}
        >
          Good morning, Priya 👋
        </div>
        <div
          style={{
            fontFamily: "Sora,sans-serif",
            fontSize: ".95rem",
            fontWeight: 700,
            color: "#fff",
            marginBottom: ".75rem",
          }}
        >
          My Orders
        </div>
        {/* KPIs */}
        <div className="d-flex gap-2 mb-3">
          {[
            ["~12 min", "ETA"],
            ["2.3 km", "Away"],
          ].map(([v, l]) => (
            <div
              key={l}
              className="flex-fill"
              style={{
                background: "rgba(14,165,233,.12)",
                border: "1px solid rgba(14,165,233,.2)",
                borderRadius: 10,
                padding: ".5rem .45rem",
              }}
            >
              <div
                style={{
                  fontSize: ".82rem",
                  fontWeight: 700,
                  color: "#38bdf8",
                }}
              >
                {v}
              </div>
              <div
                style={{ fontSize: ".52rem", color: "#64748b", marginTop: 2 }}
              >
                {l}
              </div>
            </div>
          ))}
        </div>
        {/* Orders */}
        <div className="flex-fill d-flex flex-column gap-2">
          {orders.map((o) => (
            <div key={o.name} className="montclair-home-phone-order">
              <div className="montclair-home-phone-ico">{o.ico}</div>
              <div className="flex-fill" style={{ minWidth: 0 }}>
                <div
                  style={{
                    fontSize: ".58rem",
                    fontWeight: 600,
                    color: "#e2e8f0",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {o.name}
                </div>
                <div style={{ fontSize: ".52rem", color: "#64748b" }}>
                  {o.meta}
                </div>
              </div>
              <span
                className="montclair-home-phone-badge"
                style={{ background: o.bg, color: o.tc }}
              >
                {o.badge}
              </span>
            </div>
          ))}
        </div>
        {/* Bottom nav */}
        <div className="montclair-home-phone-nav">
          <div className="d-flex flex-column align-items-center gap-1">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="#38bdf8">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
            <div
              style={{
                width: 4,
                height: 4,
                borderRadius: "50%",
                background: "#06b6d4",
              }}
            />
          </div>
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#64748b"
            strokeWidth="2"
          >
            <circle cx="9" cy="21" r="1" />
            <circle cx="20" cy="21" r="1" />
            <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
          </svg>
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#64748b"
            strokeWidth="2"
          >
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
      </div>
    </div>
  );
}

/* ── App Screen Mockups ─────────────────────────────────────── */
function AppScreens() {
  return (
    <div className="d-flex justify-content-center align-items-flex-end gap-3 position-relative py-3">
      <div
        style={{
          position: "absolute",
          width: 300,
          height: 300,
          borderRadius: "50%",
          background:
            "radial-gradient(circle,rgba(14,165,233,.13),transparent 70%)",
          pointerEvents: "none",
        }}
      />

      {/* Main screen — GPS tracking */}
      <div
        style={{
          width: 182,
          height: 365,
          borderRadius: 24,
          background: "linear-gradient(170deg,#1e3a5f,#0c2340)",
          border: "2px solid rgba(255,255,255,.1)",
          boxShadow: "0 24px 50px rgba(0,0,0,.4)",
          overflow: "hidden",
          position: "relative",
          zIndex: 2,
          flexShrink: 0,
        }}
      >
        <div
          className="d-flex flex-column h-100"
          style={{ padding: ".82rem .75rem" }}
        >
          <div
            style={{
              width: 62,
              height: 14,
              background: "#000",
              borderRadius: "0 0 8px 8px",
              margin: "0 auto .7rem",
            }}
          />
          <div
            style={{
              fontSize: ".52rem",
              color: "#64748b",
              textTransform: "uppercase",
              letterSpacing: ".06em",
              marginBottom: ".3rem",
              fontWeight: 600,
            }}
          >
            Live Tracking
          </div>
          <div
            style={{
              fontFamily: "Sora,sans-serif",
              fontSize: ".78rem",
              fontWeight: 700,
              color: "#fff",
              marginBottom: ".65rem",
            }}
          >
            Driver is 2.3 km away
          </div>
          {/* Map */}
          <div
            className="montclair-home-dl-map flex-fill"
            style={{ borderRadius: 11, marginBottom: ".62rem" }}
          >
            <div className="montclair-home-dl-map-grid" />
            <div className="montclair-home-dl-pulse">
              <div className="montclair-home-dl-dot" />
            </div>
            <svg
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
              }}
              viewBox="0 0 182 200"
              preserveAspectRatio="none"
            >
              <path
                d="M24 162 Q48 128 68 108 Q102 74 122 54 Q144 34 155 22"
                stroke="rgba(56,189,248,.5)"
                strokeWidth="1.5"
                fill="none"
                strokeDasharray="5 3"
              />
              <circle cx="24" cy="162" r="4" fill="#10b981" />
              <circle cx="155" cy="22" r="4" fill="#38bdf8" />
            </svg>
          </div>
          {/* ETA strip */}
          <div
            className="d-flex align-items-center gap-2"
            style={{
              background: "rgba(14,165,233,.14)",
              border: "1px solid rgba(14,165,233,.25)",
              borderRadius: 8,
              padding: ".4rem .6rem",
            }}
          >
            <div
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: "#10b981",
                flexShrink: 0,
              }}
            />
            <div style={{ fontSize: ".56rem", color: "#94a3b8", flex: 1 }}>
              Driver Raju · 20L Can
            </div>
            <div
              style={{ fontSize: ".56rem", fontWeight: 700, color: "#38bdf8" }}
            >
              ~12 min
            </div>
          </div>
        </div>
      </div>

      {/* Side screen — quick order */}
      <div
        style={{
          width: 155,
          height: 312,
          borderRadius: 22,
          background: "linear-gradient(170deg,#1e3a5f,#0c2340)",
          border: "2px solid rgba(255,255,255,.08)",
          boxShadow: "0 18px 40px rgba(0,0,0,.35)",
          overflow: "hidden",
          opacity: 0.72,
          flexShrink: 0,
        }}
      >
        <div
          className="d-flex flex-column h-100"
          style={{ padding: ".75rem .7rem" }}
        >
          <div
            style={{
              width: 54,
              height: 12,
              background: "#000",
              borderRadius: "0 0 7px 7px",
              margin: "0 auto .62rem",
            }}
          />
          <div
            style={{
              fontFamily: "Sora,sans-serif",
              fontSize: ".72rem",
              fontWeight: 700,
              color: "#fff",
              marginBottom: ".6rem",
            }}
          >
            Quick Order
          </div>
          <div className="d-flex flex-column gap-2 flex-fill">
            {[
              {
                ico: "💧",
                name: "20L Water Can",
                price: "₹40",
                bg: "rgba(56,189,248,.15)",
                tc: "#38bdf8",
              },
              {
                ico: "🫙",
                name: "5L Premium Jar",
                price: "₹25",
                bg: "rgba(16,185,129,.15)",
                tc: "#34d399",
              },
              {
                ico: "⭐",
                name: "Monthly Plan",
                price: "₹999",
                bg: "rgba(251,146,60,.15)",
                tc: "#fb923c",
              },
            ].map((p) => (
              <div
                key={p.name}
                className="d-flex align-items-center gap-2"
                style={{
                  background: "rgba(255,255,255,.04)",
                  borderRadius: 7,
                  padding: ".4rem",
                }}
              >
                <div
                  style={{
                    width: 20,
                    height: 20,
                    borderRadius: 5,
                    background: "rgba(14,165,233,.18)",
                    fontSize: ".62rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  {p.ico}
                </div>
                <div
                  style={{
                    fontSize: ".54rem",
                    color: "#e2e8f0",
                    fontWeight: 600,
                    flex: 1,
                  }}
                >
                  {p.name}
                </div>
                <span
                  style={{
                    fontSize: ".47rem",
                    fontWeight: 700,
                    padding: ".1rem .35rem",
                    borderRadius: 100,
                    background: p.bg,
                    color: p.tc,
                  }}
                >
                  {p.price}
                </span>
              </div>
            ))}
          </div>
          <div
            style={{
              background: "linear-gradient(135deg,#0369a1,#06b6d4)",
              borderRadius: 8,
              padding: ".5rem",
              textAlign: "center",
              fontSize: ".6rem",
              fontWeight: 700,
              color: "#fff",
              marginTop: ".6rem",
            }}
          >
            Order Now →
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Download Phone ─────────────────────────────────────────── */
function DlPhone() {
  return (
    <div
      className="d-flex justify-content-center align-items-flex-end position-relative"
      style={{ height: 430 }}
    >
      <div className="montclair-home-dl-phone-back" />
      <div className="montclair-home-dl-phone">
        <div
          className="d-flex flex-column h-100"
          style={{ padding: "1rem .9rem" }}
        >
          <div
            style={{
              width: 68,
              height: 18,
              background: "#000",
              borderRadius: "0 0 10px 10px",
              margin: "0 auto .85rem",
            }}
          />
          <div
            style={{
              fontFamily: "Sora,sans-serif",
              fontSize: ".72rem",
              fontWeight: 700,
              color: "#fff",
              marginBottom: ".18rem",
            }}
          >
            Track Your Order
          </div>
          <div
            style={{
              fontSize: ".6rem",
              color: "#64748b",
              marginBottom: ".75rem",
            }}
          >
            Delivery in ~12 minutes
          </div>
          <div className="montclair-home-dl-map flex-fill">
            <div className="montclair-home-dl-map-grid" />
            <div className="montclair-home-dl-pulse">
              <div className="montclair-home-dl-dot" />
            </div>
            <svg
              style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
              }}
              viewBox="0 0 215 200"
              preserveAspectRatio="none"
            >
              <path
                d="M28 164 Q56 134 76 114 Q114 76 134 56 Q154 38 172 28"
                stroke="rgba(56,189,248,.5)"
                strokeWidth="2"
                fill="none"
                strokeDasharray="6 4"
              />
              <circle cx="28" cy="164" r="5" fill="#10b981" />
              <circle cx="172" cy="28" r="5" fill="#38bdf8" />
            </svg>
          </div>
          <div
            className="d-flex align-items-center gap-2"
            style={{
              background: "rgba(14,165,233,.12)",
              border: "1px solid rgba(14,165,233,.2)",
              borderRadius: 10,
              padding: ".58rem .76rem",
            }}
          >
            <div
              style={{
                width: 7,
                height: 7,
                borderRadius: "50%",
                background: "#10b981",
                boxShadow: "0 0 6px #10b981",
                flexShrink: 0,
              }}
            />
            <div className="flex-fill">
              <div
                style={{
                  fontSize: ".62rem",
                  fontWeight: 700,
                  color: "#e2e8f0",
                }}
              >
                Driver Raju is on the way
              </div>
              <div style={{ fontSize: ".57rem", color: "#94a3b8" }}>
                2.3 km away · 20L Can × 1
              </div>
            </div>
            <div
              style={{ fontSize: ".62rem", fontWeight: 700, color: "#38bdf8" }}
            >
              ~12 min
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ── Scroll Reveal Hook ─────────────────────────────────────── */
function useReveal(ref) {
  useEffect(() => {
    const root = ref?.current || document;
    const els = root.querySelectorAll(".montclair-home-reveal");
    const obs = new IntersectionObserver(
      (entries) =>
        entries.forEach((e) => {
          if (e.isIntersecting)
            e.target.classList.add("montclair-home-visible");
        }),
      { threshold: 0.1 },
    );
    els.forEach((el, i) => {
      el.style.transitionDelay = `${(i % 4) * 0.08}s`;
      obs.observe(el);
    });
    return () => obs.disconnect();
  }, [ref]);
}

export default function Home() {
  const rootRef = useRef(null);
  const [formSent, setFormSent] = useState(false);
  useReveal(rootRef);

  return (
    <div className="montclair-home-root" ref={rootRef}>
      <section className="montclair-home-hero py-5 py-lg-0" id="home">
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row align-items-center g-5 py-5">
            {/* Left */}
            <div className="col-12 col-lg-6">
              <div className="montclair-home-reveal">
                <h1 className="montclair-home-hero-title mb-4">
                  Pure Water
                  <br />
                  <span className="montclair-home-hero-grad">At Your Door</span>
                </h1>
                <p className="montclair-home-hero-sub mb-4">
                  India's most trusted water delivery app. Order premium
                  Montclair water in cans, jars, and bulk — tracked live,
                  delivered fast.
                </p>
                {/* Checklist */}
                <ul className="list-unstyled mb-4">
                  {[
                    "BIS-certified premium drinking water",
                    "One-tap Order",
                  ].map((t) => (
                    <li key={t} className="d-flex align-items-start gap-2 mb-2">
                      <CheckIcon />
                      <span style={{ color: "#cbd5e1", fontSize: "1rem" }}>
                        {t}
                      </span>
                    </li>
                  ))}
                </ul>
                {/* Buttons */}
                <div className="d-flex flex-wrap gap-2 mb-5">
                  <a
                    href="/assets/app/montclair-v1.apk"
                    download={true}
                    className="montclair-home-hero-btn-primary mt-3"
                  >
                    <i className="bi bi-download me-1"></i>
                    Download App
                  </a>
                </div>
              </div>
            </div>
            {/* Right — Phone */}
            <div className="col-12 col-lg-6">
              <HeroPhone />
            </div>
          </div>
        </div>
      </section>

      {/* ══ 4 APP FEATURES ══════════════════════════════════════ */}
      <section className="py-8 bg-white" id="features-quick">
        <div className="container pb-4 pt-1">
          <div className="text-center mb-5 montclair-home-reveal">
            <span className="montclair-home-chip mb-3">Why Montclair</span>
            <h2 className="montclair-home-section-title display-5 fw-bold mt-2">
              Built Around You
            </h2>
            <p
              className="lead text-muted mt-2 pb-2 lh-sm mx-auto"
              style={{ maxWidth: 540 }}
            >
              Every feature in the Montclair app is designed to make getting
              pure water effortless.
            </p>
          </div>
          <div className="row g-3">
            {[
              {
                emoji: "⚡",
                title: "Order in 60 Seconds",
                desc: "Pick your product, pay, done. No calls. No queues. Your Montclair order placed before your kettle boils.",
              },
              {
                emoji: "🏅",
                title: "BIS Certified Quality",
                desc: "Every Montclair can and jar meets BIS standards. Multi-stage RO + UV purification in every single drop.",
              },
              {
                emoji: "📍",
                title: "Live GPS Tracking",
                desc: "Watch your delivery move in real time on a live map. Know your driver's ETA down to the minute.",
              },
              {
                emoji: "🔁",
                title: "Unlimited Subscriptions",
                desc: "Set a daily or weekly Montclair delivery and forget about water entirely. Pause or cancel anytime.",
              },
            ].map((f) => (
              <div
                key={f.title}
                className="col-12 col-sm-6 col-lg-3 montclair-home-reveal"
              >
                <div className="montclair-home-feat-card text-center text-lg-start">
                  <div className="montclair-home-feat-icon mx-auto mx-lg-0">
                    {f.emoji}
                  </div>
                  <h4
                    className="fw-bold mb-2"
                    style={{ fontFamily: "Sora,sans-serif" }}
                  >
                    {f.title}
                  </h4>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: ".9rem", lineHeight: 1.65 }}
                  >
                    {f.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ APP FEATURES (with screen mockups) ════════════════ */}
      <section className="py-8" style={{ background: "#f8fafd" }} id="features">
        <div className="container">
          <div className="row align-items-center g-5">
            {/* Screen mockups */}
            <div className="col-12 col-lg-6 order-2 order-lg-1 montclair-home-reveal">
              <AppScreens />
            </div>
            {/* Feature list */}
            <div className="col-12 col-lg-6 order-1 order-lg-2 montclair-home-reveal">
              <span className="montclair-home-chip mb-3">App Features</span>
              <h2 className="montclair-home-section-title display-5 fw-bold mt-2 mb-3">
                Everything You Need
                <br />
                in One App
              </h2>
              <p className="text-muted fs-5 mb-4">
                The Montclair app puts full control in your hands — from
                ordering to live tracking to subscriptions.
              </p>
              <div className="d-flex flex-column gap-4">
                {[
                  {
                    emoji: "📍",
                    title: "Live Order Tracking",
                    desc: "See your Montclair delivery. Know exactly when to expect it.",
                  },
                  {
                    emoji: "🔁",
                    title: "One-tap Reorder & Subscribe",
                    desc: "Reorder in a single tap.",
                  },
                  {
                    emoji: "🔔",
                    title: "Smart Notifications",
                    desc: "Step — accepted, on the way and delivered.",
                  },
                  {
                    emoji: "💳",
                    title: "Flexible Payments",
                    desc: "Pay via UPI, card, or cash on delivery.",
                  },
                ].map((f) => (
                  <div key={f.title} className="d-flex gap-3 align-items-start">
                    <div
                      style={{
                        width: 50,
                        height: 50,
                        borderRadius: 14,
                        background: "linear-gradient(135deg,#e0f2fe,#dbeafe)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "1.35rem",
                        flexShrink: 0,
                        boxShadow: "0 2px 8px rgba(14,165,233,.12)",
                      }}
                    >
                      {f.emoji}
                    </div>
                    <div>
                      <div
                        className="fw-bold mb-0"
                        style={{
                          fontFamily: "Sora,sans-serif",
                          fontSize: "1rem",
                        }}
                      >
                        {f.title}
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: ".88rem", lineHeight: 1.3 }}
                      >
                        {f.desc}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ══ PRODUCTS ════════════════════════════════════════════ */}
      <section className="py-8 montclair-home-products" id="products">
        <div className="container">
          <div className="text-center montclair-home-reveal">
            <span className="montclair-home-chip mb-3">Our Products</span>
            <h2 className="montclair-home-section-title display-5 fw-bold mt-2">
              Water for Every Need
            </h2>
            <p
              className="lead text-muted mt-2 mx-auto"
              style={{ maxWidth: 560 }}
            >
              From single households to large corporates — choose your Montclair
              plan and we'll handle the rest.
            </p>
          </div>
        </div>
      </section>

      {/* ══ TESTIMONIALS ════════════════════════════════════════ */}
      <section className="py-8 bg-white">
        <div className="container pb-4">
          <div className="text-center mb-5 montclair-home-reveal">
            <span className="montclair-home-chip mb-3">Customer Reviews</span>
            <h2 className="montclair-home-section-title display-5 fw-bold mt-2 mb-0">
              Loved by Thousands
            </h2>
            <p className="text-muted lead">
              Real people. Real Montclair deliveries. Real satisfaction.
            </p>
          </div>
          <div className="row g-3">
            {[
              {
                s: "★★★★★",
                t: "The live tracking is a game-changer. I can see exactly where my water is and my kids love watching the delivery on the map. Always right on time!",
                n: "Priya Kumari",
                r: "Homemaker, Boring Road",
                i: "P",
                g: "linear-gradient(135deg,#7c3aed,#a855f7)",
              },
              {
                s: "★★★★★",
                t: "Set up a weekly Montclair subscription for our office and completely forgot about it — in the best way. Billing is clear, delivery is always on time.",
                n: "Amit Verma",
                r: "Operations Manager, TechCorp",
                i: "A",
                g: "linear-gradient(135deg,#0369a1,#06b6d4)",
              },
              {
                s: "★★★★☆",
                t: "The reorder button is genius. One tap and done. The subscription saved our restaurant almost 20% vs buying individually. Support team is very responsive.",
                n: "Ravi Shankar",
                r: "Owner, Spice Garden Restaurant",
                i: "R",
                g: "linear-gradient(135deg,#059669,#10b981)",
              },
            ].map((tc) => (
              <div key={tc.n} className="col-12 col-md-4 montclair-home-reveal">
                <div className="montclair-home-testi-card d-flex flex-column">
                  <div
                    style={{
                      color: "#f59e0b",
                      fontSize: "1.05rem",
                      letterSpacing: ".1rem",
                      marginBottom: ".9rem",
                    }}
                  >
                    {tc.s}
                  </div>
                  <p
                    className="text-muted flex-fill"
                    style={{
                      fontSize: ".92rem",
                      lineHeight: 1.4,
                      fontStyle: "italic",
                      marginBottom: "1.4rem",
                    }}
                  >
                    "{tc.t}"
                  </p>
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="montclair-home-testi-avatar"
                      style={{ background: tc.g }}
                    >
                      {tc.i}
                    </div>
                    <div>
                      <div className="fw-bold" style={{ fontSize: ".9rem" }}>
                        {tc.n}
                      </div>
                      <div
                        className="text-muted"
                        style={{ fontSize: ".76rem", marginTop: -5 }}
                      >
                        {tc.r}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ HOW IT WORKS ════════════════════════════════════════ */}
      <section className="py-8" style={{ background: "#f8fafd" }} id="how">
        <div className="container py-3">
          <div className="text-center mb-5 montclair-home-reveal">
            <span className="montclair-home-chip mb-3">Simple Process</span>
            <h2 className="montclair-home-section-title display-5 fw-bold mt-2">
              Order in Under 60 Seconds
            </h2>
            <p
              className="text-muted lead mt-2 mx-auto"
              style={{ maxWidth: 520 }}
            >
              Built for speed. Pure Montclair water at your door — no phone
              calls, no hassle.
            </p>
          </div>
          <div className="row g-4 justify-content-center">
            {[
              {
                n: "1",
                title: "Download the App",
                desc: "Free on Android and iOS. Browse products without signing up.",
              },
              {
                n: "2",
                title: "Pick Your Product",
                desc: "Cans, jars, or bulk plans. Single orders and subscriptions.",
              },
              {
                n: "3",
                title: "Pay Securely",
                desc: "UPI, card, or cash on delivery. Encrypted and instant.",
              },
              {
                n: "4",
                title: "Track & Receive",
                desc: "Watch your delivery live on the map. Notified on arrival.",
              },
            ].map((s, i) => (
              <div
                key={s.n}
                className="col-12 col-sm-6 col-lg-3 montclair-home-reveal"
              >
                <div className="text-center position-relative">
                  {i < 3 && (
                    <div className="montclair-home-step-connector d-none d-lg-block" />
                  )}
                  <div className="montclair-home-step-num">{s.n}</div>
                  <h5
                    className="fw-bold mb-2"
                    style={{ fontFamily: "Sora,sans-serif" }}
                  >
                    {s.title}
                  </h5>
                  <p
                    className="text-muted mb-0"
                    style={{ fontSize: ".88rem", lineHeight: 1.4 }}
                  >
                    {s.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══ DOWNLOAD ════════════════════════════════════════════ */}
      <section className="py-8 montclair-home-cta" id="download">
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row align-items-center g-5">
            <div className="col-12 col-lg-6 montclair-home-reveal">
              <span
                style={{
                  display: "inline-block",
                  background: "rgba(56,189,248,.15)",
                  border: "1px solid rgba(56,189,248,.2)",
                  color: "#7dd3fc",
                  fontSize: ".76rem",
                  fontWeight: 700,
                  letterSpacing: ".06em",
                  textTransform: "uppercase",
                  padding: ".35rem 1.9rem",
                  borderRadius: 100,
                  marginBottom: "1rem",
                }}
              >
                Free Download
              </span>
              <h2 className="montclair-home-section-title display-5 fw-bold text-white mt-2 mb-3">
                Get the App.
                <br />
                Get Pure Montclair Water.
              </h2>
              <p
                style={{
                  color: "#94a3b8",
                  fontSize: "1.05rem",
                  lineHeight: 1.75,
                  maxWidth: "44ch",
                }}
              >
                Order, track, subscribe — all from a beautifully simple app.
                Android and iOS, completely free.
              </p>
              <div className="d-flex flex-wrap gap-3 mt-4">
                {[["Google Play", "Get it on"]].map(([name, sub]) => (
                  <a
                    href="/assets/app/montclair-v1.apk"
                    download={true}
                    key={name}
                    className="montclair-home-store-badge"
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 24 24"
                      fill="white"
                    >
                      <path d="M3 20.5v-17a.5.5 0 01.73-.44l15 8.5a.5.5 0 010 .88l-15 8.5A.5.5 0 013 20.5z" />
                    </svg>
                    <div>
                      <div
                        style={{
                          fontSize: ".6rem",
                          color: "rgba(255,255,255,.6)",
                          textTransform: "uppercase",
                          letterSpacing: ".05em",
                        }}
                      >
                        {sub}
                      </div>
                      <div
                        style={{
                          fontFamily: "Sora,sans-serif",
                          fontSize: ".95rem",
                          fontWeight: 500,
                          color: "#fff",
                        }}
                      >
                        {name}
                      </div>
                    </div>
                  </a>
                ))}
              </div>
            </div>
            <div className="col-12 col-lg-6 montclair-home-reveal">
              <DlPhone />
            </div>
          </div>
        </div>
      </section>

      {/* ══ CTA SECTION ═════════════════════════════════════════ */}
      <section className="py-8 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10 col-12 text-center montclair-home-reveal">
              <span className="montclair-home-chip mb-3">
                Pure Water, Delivered Daily
              </span>
              <h2 className="montclair-home-section-title display-4 fw-bold mt-2 mb-3">
                Download Montclair — It's Free
              </h2>
              <p
                className="lead text-muted mb-5 mx-auto"
                style={{ maxWidth: 520 }}
              >
                Join 50,000+ happy customers across Kerela getting fresh
                Montclair water delivered to their door every single day.
              </p>
              <div className="d-flex flex-wrap gap-2 justify-content-center">
                <a
                  href="/assets/app/montclair-v1.apk"
                  download={true}
                  className="btn btn-primary montclair-home-cta-btn text-white"
                >
                  Download the App
                </a>
                <a
                  href="#contact"
                  className="btn montclair-home-cta-outline"
                  style={{
                    border: "2px solid #0369a1",
                    color: "#0369a1",
                    borderRadius: 100,
                    fontWeight: 600,
                    padding: ".95rem 2.4rem",
                  }}
                >
                  Talk to Our Team
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
